export interface PortalTenant {
  tenant_id: number
  tenant_name: string
  slug: string
}

declare global {
  interface Window {
    __PORTAL_TENANT__?: PortalTenant | null
  }
}

/**
 * Returns tenant data injected by the Cloudflare Worker for custom domain
 * requests. Returns null on first-party portal domains (e.g. portal.eq-cloud.com).
 */
export function getInjectedTenant(): PortalTenant | null {
  return window.__PORTAL_TENANT__ ?? null
}
